export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/view-more-arrow.d23225c7-0c2d57.svg";